import { render, staticRenderFns } from "./manxiangq.vue?vue&type=template&id=32fb4cbc&scoped=true&"
import script from "./manxiangq.vue?vue&type=script&lang=js&"
export * from "./manxiangq.vue?vue&type=script&lang=js&"
import style0 from "./manxiangq.vue?vue&type=style&index=0&id=32fb4cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb4cbc",
  null
  
)

export default component.exports